export const waitForElement = (
  selector,
  timeout = 5000,
  interval = 100
) => {
  return new Promise((resolve, reject) => {
    const start = Date.now();

    const timer = setInterval(() => {
      const el = document.querySelector(selector);

      if (el) {
        clearInterval(timer);
        resolve(el);
      }

      if (Date.now() - start > timeout) {
        clearInterval(timer);
        reject(`Element not found: ${selector}`);
      }
    }, interval);
  });
};
